export default __webpack_public_path__ + "static/media/personalinfo-icon.9440fdb2.svg";